import axios, { AxiosError, AxiosResponse } from 'axios';
import { message } from 'antd';

//import { axiosApiInstance } from '../../services/axiosApiInstance';
import customLocalStorage from '../../services/localStorageWithExpire';
import { setCookie } from '../../services/utils';

const api = `${process.env.REACT_APP_API_URL}/api/v1/auth`;

export interface LoginPayload {
    email: string;
    password: string;
    otp?: string;
}

export interface SignupPayload {
    email: string;
}

interface LoginResponse {
    access_token: string;
    refresh_token: string;
    token_type: string;
    id_token: string;
    expires_in: 0;
    client_id: string
}

interface RefreshToken {
    access_token: string,
    expires_in: 0,
    token_type: "Bearer"
}
const login = async ({ email, password, otp }: LoginPayload) => {

    const endpoint = `${api}/login`

    let payload: any = {
        "email": email,
        "password": password
    }

    if (otp !== undefined && otp !== null) {
        payload['otp'] = otp;
    }

    try {
        const res: AxiosResponse = await axios.post(
            endpoint,
            payload
        );

        if (res && res.data) {
            let { access_token, refresh_token, token_type, expires_in, client_id } = res.data as LoginResponse;

            customLocalStorage.setWithExpire(
                "ACCESS_TOKEN",
                `${token_type} ${access_token}`,
                expires_in
            );

            // localStorage.setItem("ACCESS_TOKEN", `${token_type} ${access_token}`);
            localStorage.setItem("REFRESH_TOKEN", `${refresh_token}`);
            localStorage.setItem("CLIENT_ID", `${client_id}`);

            // set cookie
            setCookie("token", access_token, expires_in);
        }
    } catch (err: any) {
        if (err?.name && err?.name === "AxiosError") {
            const { status, statusText, data } = err.response;
            let newErrorObj: any = { status, statusText, data }
            throw new AxiosError(newErrorObj);
        }
        throw Error("Unknown Error");
    }
}

const signup = async ({email}: SignupPayload) => {
    const endpoint = `${api}/signup`;
    const payload = {
        email: email
    }

    try {

        const res: AxiosResponse = await axios.post(
            endpoint,
            payload
        );

        if (res && res.data) {
            console.log(res)
            // return res;
        }

        // return undefined;

    } catch (err: any) {
        if (err?.name && err?.name === "AxiosError") {
            const { status, statusText, data } = err.response;
            const newErrorObj: any = { status, statusText, data }
            throw new AxiosError(newErrorObj)
        }
        throw Error("Unknown Error")
    }
}

const logout = async () => {
    const endpoint = `${api}/revoke-token`
    
    try {
        await axios.post(
            endpoint,
            {
                client_id: localStorage.getItem("CLIENT_ID"),
                token: localStorage.getItem("REFRESH_TOKEN")
            }
        )
    } catch (err) {
        console.log('error_auth_refresh', err);
        if (axios.isAxiosError(err)) {
            if (err.response && err.response.data) {
                const { reason, message: msg } = err.response.data.detail;
                let msgObj = JSON.parse(msg);
                message.error(
                    msgObj["error_description"] ? msgObj["error_description"] : reason,
                    5
                )
            }
        }
        else {
            message.error(
                "Some error occurred",
                5
            )
        }
    }
}

const refreshToken = async () => {

    const endpoint = `${api}/refresh-token`

    try {

        const payload = {
            "client_id": localStorage.getItem("CLIENT_ID"),
            "refresh_token": localStorage.getItem("REFRESH_TOKEN")
        }

        let res = await axios.post(
            endpoint,
            payload,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
        );
        if (res && res.data) {
            let { access_token, token_type, expires_in } = res.data as RefreshToken;
            // localStorage.setItem("ACCESS_TOKEN", `${token_type} ${access_token}`);
            // localStorage.setItem("EXPIRES_IN", `${expires_in}`);
            customLocalStorage.setWithExpire(
                "ACCESS_TOKEN",
                `${token_type} ${access_token}`,
                expires_in
            );

            // set cookie
            setCookie("token", access_token, expires_in);
        }

    } catch (err) {
        console.log('error_auth_refresh', err);
        if (axios.isAxiosError(err)) {
            if (err.response && err.response.data) {
                const { reason, message: msg } = err.response.data.detail;
                let msgObj = JSON.parse(msg);
                message.error(
                    msgObj["error_description"] ? msgObj["error_description"] : reason,
                    5
                )
            }
        }
        else {
            message.error(
                "Some error occurred",
                5
            )
        }

    }

}

const apiFunc = {
    login,
    signup,
    logout,
    refreshToken
}

export default apiFunc;